<div class="order-info__tab">
  <div class="basic-data">
    <h4> الفاحص</h4>
    <a href="pages/inspectors/inspector-profile/{{orders?.order_details?.order_inspector?.pk}}">{{orders?.order_details?.order_inspector?
      orders.order_details?.order_inspector?.full_name : '-'}} </a>
  </div>
  <div class="basic-data">
    <h4> بدء عملية الفحص </h4>
    <p> {{orders?.started_at?orders.started_at : '-'}} </p>
  </div>
  <div class="basic-data">
    <h4> وقت تسليم التقرير </h4>
    <p> {{orders?.ended_at?orders.ended_at : '-'}} </p>
  </div>
  <div class="basic-data">
    <h4> حصة الفاحص الرئيسية </h4>
    <p> {{orders?.cost?.cost_details?.inspector_share ?? '-'}} @if
      (orders?.cost?.cost_details?.inspector_share!='-') {
      <span> ر.س </span>
      }
    </p>
  </div>
  <div class="basic-data">
    <h4> حصة الفاحص الإضافية</h4>
    <p> {{orders?.cost?.cost_details?.inspector_extra_share_total ?? '-'}}
      @if(orders?.cost?.cost_details?.inspector_extra_share_total) {
      <span> ر.س </span>
      }
    </p>
  </div>
  <div class="basic-data">
    <h4> حصة الفاحص النهائية </h4>
    <p> {{orders?.cost?.cost_details?.inspector_share_total ?? '-'}}
      @if(orders?.cost?.cost_details?.inspector_share_total) {
      <span> ر.س </span>
      }
    </p>
  </div>
  <div class="basic-data">
    <h4>هل يوجد إرجاع</h4>
    <p>
      {{orders?.cost?.cost_details?.has_refunds ? 'نعم' : 'لا'}}
    </p>
  </div>
  <div class="basic-data">
    <h4>حالة الدفع (للفاحص)</h4>
    <div class="double-action">
      <p> {{orders?.cost?.inspector_payment_status ?orders?.cost?.inspector_payment_status : '-'}}
        @if (orders?.cost?.inspector_payment_status === 'مدفوعة') {
        <img src="assets/images/svg/ellipse-green.svg" alt="">
        }
      </p>
      @if (orders?.cost?.inspector_payment_status === 'مستحقة' && roles.includes(userRoles.FINANCE)) {
      <button (click)="deliveredOrder(orders.id, paid)" class="btn btn-green">
        تم الدفع
      </button>
      }
    </div>
  </div>
  <div class="basic-data">
    <h4>تاريخ الدفع (للفاحص)</h4>
    <p>{{orders?.cost?.inspector_payment_date?orders?.cost.inspector_payment_date : '-'}}</p>
  </div>
</div>
